import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import RouteLink from 'components/common/route-link/RouteLink';
import useBundleTranslation from 'i18n';

interface NodeNameCellProps {
    text?: string;
    href?: string;
    disabled?: boolean;
    disabledLabel?: string;
    dataTestCell?: string;
}

/**
 * Knowledge Graph list Name cell (spec §6.4): the object name, muted with an inline grey
 * "Disabled" chip when the node is not effectively available to Concierge.
 */
export default function NodeNameCell({ text, href, disabled, disabledLabel, dataTestCell }: NodeNameCellProps) {
    const { t } = useBundleTranslation(['app/editor/graph/node']);

    const name = href ? (
        <Box
            component={RouteLink}
            to={href}
            data-test={dataTestCell}
            sx={{ display: 'inline-flex', alignItems: 'center' }}
        >
            {text}
        </Box>
    ) : (
        text
    );

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
            <Typography noWrap component="span" sx={{ opacity: disabled ? 0.6 : 1 }}>
                {name}
            </Typography>
            {disabled && <Chip label={disabledLabel || t('status_disabled')} size="small" color="default" />}
        </Box>
    );
}
